<template>
    <div class="my-account-wrapper">
        <div class="row">
            <div class="col-12">
                <div class="page__head-title page__head-title--orange">
                    <div class="page__head-title__text page__head-title__text--orange">Mon compte</div>
                </div>
            </div>
            <div class="col-12">
                <div class="form_ttl_first">Informations sur votre compte :</div>
            </div>
            <div class="col-12">
                <div class="form__item">
                    <div class="form__item__label form__item__label--required">Nom</div>
                    <div class="form__item__input-wrapper">
                        <input type="text" v-model="name" class="input_n" />
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="form__item">
                    <div class="form__item__label form__item__label--required">Email</div>
                    <div class="form__item__input-wrapper">
                        <input type="text" v-model="email" class="input_n" />
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
              <div class="form__item">
                <div class="form__item__label form__item__label--required">Adresse</div>
                <div class="form__item__input-wrapper">
                  <input type="text" v-model="address" class="input_n" />
                </div>
              </div>
            </div>
          <div class="col-12">
            <div class="form__item">
              <div class="form__item__label form__item__label--required">Code postal</div>
              <div class="form__item__input-wrapper">
                <input type="text" v-model="zip" class="input_n" />
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="form__item">
              <div class="form__item__label form__item__label--required">Ville</div>
              <div class="form__item__input-wrapper">
                <input type="text" v-model="city" class="input_n" />
              </div>
            </div>
          </div>
            <div class="col-12">
                <div class="form__item">
                    <div class="form__item__label form__item__label--required">Téléphone professionnel</div>
                    <div class="form__item__input-wrapper">
                        <input type="text" v-model="phone_work" class="input_n" />
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="form__item">
                    <div class="form__item__label form__item__label--required">Téléphone personnel</div>
                    <div class="form__item__input-wrapper">
                        <input type="text" v-model="phone_personal" class="input_n" />
                    </div>
                </div>
            </div>
            <div class="col-12" v-if="id === MutuaideRep">
                <div class="form__item">
                    <div class="form__item__label">IBAN</div>
                    <div class="form__item__input-wrapper">
                        <input type="text" v-model="iban" class="input_n" />
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="form__item justify-content-center mt-3 mb-3">
                    <div class="form__item__submit">
                        <input type="button" name="Submit" @click="saveRepresentativeDetails" value="Envoyer" class="form_bt form__item__submit__button" />
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="form_ttl">Si vous voulez modifier votre mot de passe:</div>
            </div>
            <div class="col-12">
                <div class="form__item">
                    <div class="form__item__label form__item__label--medium form__item__label--required">Entrez votre mot de passe actuel</div>
                    <div class="form__item__input-wrapper form__item__input-wrapper--medium">
                        <input type="password" v-model="old_password" class="input_n" autocomplete="new-password"/>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="form__item">
                    <div class="form__item__label form__item__label--medium form__item__label--required">Entrez votre nouveau mot de passe</div>
                    <div class="form__item__input-wrapper form__item__input-wrapper--medium">
                        <input type="password" v-model="password" class="input_n" />
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="form__item">
                    <div class="form__item__label form__item__label--medium form__item__label--required">Confirmez votre nouveau mot de passe</div>
                    <div class="form__item__input-wrapper form__item__input-wrapper--medium">
                        <input type="password" v-model="password_confirmation" class="input_n" />
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="form__item justify-content-center mt-3 mb-3">
                    <div class="form__item__submit">
                        <input type="button" name="Submit" @click="saveNewPassword" value="Envoyer" class="form_bt form__item__submit__button" />
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

    import {validationMixin} from 'vuelidate'
    import {required, email} from 'vuelidate/lib/validators'
    import Multiselect from 'vue-multiselect'

    export default {
        name: 'MyAccountRepresentative',
        data() {
            return {
                id: null,
                name: null,
                email: null,
                address: '',
                zip: '',
                city: '',
                phone_work: '',
                phone_personal: '',
                old_password: null,
                password: null,
                password_confirmation: null,
                availableTaxes: [],
                iban: null,
                MutuaideRep: 13
            }
        },
        components: {Multiselect},
        mixins: [
            validationMixin
        ],
        computed: {
            user() {
                return this.$store.state.userInfo;
            }
        },
        watch: {
            '$store.getters.getAuthUserInfo': function(user) {
                this.parseUser(user);
            }
        },
        methods: {
            parseUser(user) {
              this.email = user.email;
              this.id = user.representative.id || null;

              if (user.representative) {
                  this.name = user.representative.name;
                  this.address = user.representative.address;
                  this.zip = user.representative.zip;
                  this.city = user.representative.city;
                  this.phone_work = user.representative.phone_work;
                  this.phone_personal = user.representative.phone_personal;
                  this.tax = user.representative.tax;
                  this.iban = user.representative.iban ? user.representative.iban : null;
              }
            },
            saveRepresentativeDetails() {
                if (!this.$v.$invalid && this.id) {
                    let url = `representatives/${this.id}`;
                    let data = {
                        name: this.name,
                        email: this.email,
                        phone_work: this.phone_work,
                        phone_personal: this.phone_personal,
                        address: this.address,
                        zip: this.zip,
                        city: this.city,
                        tax_id: this.tax.id,
                        iban: this.iban,
                    };

                    this.apiUpdate(url, data).then(response => {
                        console.log(response.data);
                        this.showSuccessNotification('User details successfully updated.');
                        this.$store.dispatch('updateRepresentativeInfo', response.data);
                        this.$store.dispatch('updateUserInfo', response.data.user);
                    }).catch(error => {
                        this.showErrorNotification(error);
                    });
                } else {
                    this.showWarningNotification('Please check up that all fields are correct.');
                }
            },
            saveNewPassword() {
                let url = this.user.id + '/change-password';
                let data = {
                    old_password: this.old_password,
                    password: this.password,
                    password_confirmation: this.password_confirmation,
                };

                this.apiUpdate(url, data).then(response => {
                    this.showSuccessNotification('User password successfully updated.');
                    this.clearPasswordForm()
                }).catch(error => {
                    this.showErrorNotification(error);
                });
            },
            clearPasswordForm() {
                this.old_password = '';
                this.password = '';
                this.password_confirmation = '';
            },
        },
        mounted() {
            if (this.user && this.user.representative) {
                this.parseUser(this.user);
            }
        },
        validations: {
            name: {
              required
            },
            email: {
                email
            },
            phone_work: {
              required
            },
            phone_personal: {
              required
            },
            address: {
              required
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Profile/MyAccountRepresentative.vue